import React from "react";

import {
  Container,
  Wrapper,
  Strong,
  OL,
  LI,
  Heading,
  GlobalCss,
} from "./style";
import { Typography } from "@/foundation/Typography/V1";
import theme from "@/foundation/Theme";

export const FaqPageContent = (props) => {
  const { webMode = false } = props || {};

  return (
    <Container flexDirection="column">
      {webMode && (
        <Typography
          fontFamily={"var(--font-500)"}
          color={theme.colors.gray_100}
          variant="heading2"
          fontSize={["20px", "25px", "30px"]}
        >
          Frequently asked questions
        </Typography>
      )}
      <Wrapper flexDirection={"column"} showHeightGap={webMode}>
        <Typography
          variant="paragraph2"
          fontFamily={"var(--font-400)"}
          color={theme.colors.gray_100}
        >
          Hi there,
          <br />
          <br />
          Welcome to Shyft! We are thrilled that you’ve taken this crucial step
          towards building a healthier body and mind for yourself. Please find
          below some frequently asked questions (FAQs) that may help you get
          started with our community section.
        </Typography>
        <OL pl={"0px"}>
          <LI>
            <Heading variant="paragraph2" color={theme.colors.gray_100}>
              <Strong>What are Shyft Communities?</Strong>
            </Heading>
            <OL>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  It's an online community for anyone who wants to talk about
                  their health journey, get support, or meet others who are
                  going through similar experiences.
                </Typography>
              </LI>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                  textAlign="justify"
                >
                  We created the Shyft Communities as a user-driven platform to
                  give you the opportunity to build a supportive online network.
                </Typography>
              </LI>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                  textAlign="justify"
                >
                  Consider it your safe space!
                </Typography>
              </LI>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                  textAlign="justify"
                >
                  Once you join, you can select health interests or goals that
                  are most relevant to you and share your feelings and thoughts
                  via posts, that can include images. You can also like, comment
                  and star posts that you find inspiring or interesting.
                </Typography>
              </LI>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                  textAlign="justify"
                >
                  It's also an opportunity to connect with others who will
                  understand what you're going through and find advice from
                  Shyft experts.
                </Typography>
              </LI>
            </OL>
          </LI>

          <LI>
            <Heading variant="paragraph2" color={theme.colors.gray_100}>
              <Strong>What is the purpose of Shyft Communities?</Strong>
            </Heading>
            <OL>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  Our goal is to build an online space where people know that
                  they are cared for and heard. We want to help you find your
                  tribe of supporters!
                </Typography>
              </LI>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                  textAlign="justify"
                >
                  It can be tough to navigate health difficulties alone, and
                  through our Shyft Communities, we hope to help each member
                  feel like they belong and that their worries are legitimate.
                </Typography>
              </LI>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                  textAlign="justify"
                >
                  We're creating a community of people who encourage, support
                  and advise eachother as they live through similar health
                  experiences or work towards the same health goals.
                </Typography>
              </LI>
            </OL>
          </LI>

          <LI>
            <Heading variant="paragraph2" color={theme.colors.gray_100}>
              <Strong>How can I join Shyft Communities? </Strong>
            </Heading>
            <OL>
              <Typography
                fontFamily={"var(--font-400)"}
                variant="paragraph2"
                color={theme.colors.gray_100}
              >
                Once you log into your Shyft account on the app, you can click
                on Communities in the bottom menu bar and select the Interests
                you want to follow. This will take you to the Shyft Communities.
              </Typography>
            </OL>
          </LI>

          <LI>
            <Heading variant="paragraph2" color={theme.colors.gray_100}>
              <Strong>Who can join Shyft Communities? </Strong>
            </Heading>
            <OL>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  The Shyft Communities is for anyone who wants to find a safe
                  space to talk about their health concerns or find support for
                  their health goals.
                </Typography>
              </LI>

              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  We encourage people to select the interests that are relevant
                  to them so they can ask questions, share their progress, speak
                  to others who are on the same journey.
                </Typography>
              </LI>
            </OL>
          </LI>

          <LI>
            <Heading variant="paragraph2" color={theme.colors.gray_100}>
              <Strong>
                What are health Interests or Goals within Communities?
              </Strong>
            </Heading>
            <OL>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  Within the Shyft Communities, there are several Interests or
                  Goals related to different health themes. Currently, we have
                  ten health categories - Prenatal health, Postnatal health,
                  Managing PCOS, Managing Thyroid, Gut health, General Wellness,
                  High Blood Pressure, Managing Diabetes, Weight Management and
                  Mental Health.
                </Typography>
              </LI>

              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  As a member, you can follow Interests that you feel are
                  relevant to your concerns. Our aim is to give you a safe
                  platform to share experiences, ask questions and engage with
                  other members who you relate to.
                </Typography>
              </LI>
            </OL>
          </LI>

          <LI>
            <Heading variant="paragraph2" color={theme.colors.gray_100}>
              <Strong>How do I post something?</Strong>
            </Heading>
            <OL>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  Once you log into your Shyft account on the app, you can click
                  on Communities and select the Interests you want to follow.
                </Typography>
              </LI>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  In the bottom right corner, you will see a + sign, click on
                  that and start creating your post.
                </Typography>
              </LI>

              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  You have the option to choose a Category (interest), select a
                  title for your post, write the actual post and attach an
                  image. Once your post is ready, simply click on 'Submit post'.
                </Typography>
              </LI>
            </OL>
          </LI>

          <LI>
            <Heading variant="paragraph2" color={theme.colors.gray_100}>
              <Strong>Who can read my posts?</Strong>
            </Heading>
            <OL>
              <Typography
                fontFamily={"var(--font-400)"}
                variant="paragraph2"
                color={theme.colors.gray_100}
              >
                All other Communities members who are following a particular
                Category/Goal or Interest can read the posts you've shared.
              </Typography>
            </OL>
          </LI>

          <LI>
            <Heading variant="paragraph2" color={theme.colors.gray_100}>
              <Strong>What kind of content can I post? </Strong>
            </Heading>
            <OL>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  You can express how you deal with your daily health challenges
                  by asking a question, telling a story, or doing both. You can
                  post tips, queries, thoughts or quotes - anything that you
                  feel like!
                </Typography>
              </LI>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  The content should, ideally, be relevant to the theme of the
                  health category you've chosen. Beyond that, it is entirely up
                  to you to decide what type of health-related issue you want to
                  address. Your post may contain text, pictures, links, or a
                  combination of all three.
                </Typography>
              </LI>

              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  You're free to choose the kind of content you post, but please
                  remember that we want this to be a safe space, so any
                  inappropriate content will be marked as spam and/or removed.
                </Typography>
              </LI>
            </OL>
          </LI>

          <LI>
            <Heading variant="paragraph2" color={theme.colors.gray_100}>
              <Strong>Will I get immediate responses on my posts?</Strong>
            </Heading>
            <OL>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  It's possible that not all of your posts will receive an
                  immediate response. Your worries are still valid and relevant,
                  despite this, so don't worry. Some members won't know how to
                  respond to your specific situation or query.
                </Typography>
              </LI>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  If you require immediate help or you're in a crisis situation,
                  it may be better for you to reach out to someone in person, or
                  use emergency services.
                </Typography>
              </LI>

              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  You have the option to choose a Category (interest), select a
                  title for your post, write the actual post and attach an
                  image. Once your post is ready, simply click on 'Submit post'.
                </Typography>
              </LI>
            </OL>
          </LI>

          <LI>
            <Heading variant="paragraph2" color={theme.colors.gray_100}>
              <Strong>How can I delete my post or comment?</Strong>
            </Heading>
            <OL>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  You can delete your posts by clicking on 'Your posts' and
                  selecting the menu icon next to your post and choosing 'Delete
                  Post'.
                </Typography>
              </LI>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  To delete a comment you have made, open the post which
                  contains the comment you wish to delete. Click on the menu
                  icon next to it and select the 'Delete Comment' option.
                </Typography>
              </LI>
            </OL>
          </LI>

          <LI>
            <Heading variant="paragraph2" color={theme.colors.gray_100}>
              <Strong>How can I access my posts?</Strong>
            </Heading>
            <OL>
              <Typography
                fontFamily={"var(--font-400)"}
                variant="paragraph2"
                color={theme.colors.gray_100}
              >
                Once you're inside the Communities feed, you will see a section
                called 'Your Posts' in the top menu. Click on that to view all
                your posts in one place.
              </Typography>
            </OL>
          </LI>

          <LI>
            <Heading variant="paragraph2" color={theme.colors.gray_100}>
              <Strong>What are starred posts?</Strong>
            </Heading>
            <OL>
              <Typography
                fontFamily={"var(--font-400)"}
                variant="paragraph2"
                color={theme.colors.gray_100}
              >
                You have the option to 'star' or bookmark a post or thread that
                you find interesting, informative or inspiring.
              </Typography>
            </OL>
          </LI>

          <LI>
            <Heading variant="paragraph2" color={theme.colors.gray_100}>
              <Strong>Where can I see all my starred posts?</Strong>
            </Heading>
            <OL>
              <Typography
                fontFamily={"var(--font-400)"}
                variant="paragraph2"
                color={theme.colors.gray_100}
              >
                Once you're inside the Communities feed, you will see a section
                called 'Starred' in the top menu. Click on that to view all your
                starred posts in one place.
              </Typography>
            </OL>
          </LI>

          <LI>
            <Heading variant="paragraph2" color={theme.colors.gray_100}>
              <Strong>Can I report or post or mark it as spam?</Strong>
            </Heading>
            <OL>
              <Typography
                fontFamily={"var(--font-400)"}
                variant="paragraph2"
                color={theme.colors.gray_100}
              >
                Yes, you have the option to mark posts as spam if you feel they
                are inappropriate, unrelated to the platform or violate our
                community guidelines. Just click on the three dots on the top
                right corner of a post and hit the 'Report Spam' button. Our
                team will take the necessary next steps.
              </Typography>
            </OL>
          </LI>

          <LI>
            <Heading variant="paragraph2" color={theme.colors.gray_100}>
              <Strong>
                Will I get notified if someone likes, comments or stars my post?
              </Strong>
            </Heading>
            <OL>
              <Typography
                fontFamily={"var(--font-400)"}
                variant="paragraph2"
                color={theme.colors.gray_100}
              >
                Yes, you will receive a notification for every like, comment, or
                star on your post. You have the option to view all your
                notifications by clicking on the bell icon in the top right
                corner.
              </Typography>
            </OL>
          </LI>

          <LI>
            <Heading variant="paragraph2" color={theme.colors.gray_100}>
              <Strong>How can I interact with other community members?</Strong>
            </Heading>
            <OL>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  You can interact with other members through comments. If you
                  relate to what the person is going through, you can share your
                  own experience and reply with some advice or encouragement.
                </Typography>
              </LI>

              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  We encourage users to remain positive, uplifting and
                  non-judgemental in their interactions and responses. We want
                  all of our users to feel hear, respected and cared for.
                </Typography>
              </LI>
            </OL>
          </LI>
          {/* 
          <LI>
            <Heading variant="paragraph2" color={theme.colors.gray_100}>
              <Strong>What are Trigger Warnings?</Strong>
            </Heading>
            <OL>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  Please include a Trigger Warning at the beginning of your post
                  when sharing a triggering topics or story.
                </Typography>
              </LI>

              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  Anything that could make someone think of a traumatic event
                  from the past and could result in a negative physical, mental,
                  or emotional reaction is a trigger.
                </Typography>
              </LI>

              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  Trigger Warnings prevent people who have experienced traumatic
                  experiences from being exposed to something that might trigger
                  them.
                </Typography>
              </LI>

              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  "Would reading this post traumatize me?" Could it prompt me to
                  revisit potentially upsetting events that I'd prefer to avoid?
                  These are questions to ask yourself if you’re trying to decide
                  whether or not to add a trigger warning to your post.
                </Typography>
              </LI>
            </OL>
          </LI> */}

          <LI>
            <Heading variant="paragraph2" color={theme.colors.gray_100}>
              <Strong>What are community guidelines?</Strong>
            </Heading>
            <OL>
              <Typography
                fontFamily={"var(--font-400)"}
                variant="paragraph2"
                color={theme.colors.gray_100}
              >
                Please read our community guidelines{" "}
                <Typography
                  variant="link1"
                  link1Color={theme.colors.link2Color}
                  href={`https://betheshyft.com/communitiesguidelines/${
                    webMode ? "" : "?source=app"
                  }`}
                  target="_blank"
                >
                  here
                </Typography>
              </Typography>
            </OL>
          </LI>

          <LI>
            <Heading variant="paragraph2" color={theme.colors.gray_100}>
              <Strong>
                What happens if someone violates community guidelines?
              </Strong>
            </Heading>
            <OL>
              <Typography
                fontFamily={"var(--font-400)"}
                variant="paragraph2"
                color={theme.colors.gray_100}
              >
                We want all of our members to feel safe within the Shyft
                Communities. Any post that goes against our community guidelines
                will be taken down, and the user who made it will either get a
                warning or be banned from the platform. However, if you think
                there might have been an error, please contact us at{" "}
                <Strong>communities@betheshyft.com</Strong>
              </Typography>
            </OL>
          </LI>

          <LI>
            <Heading variant="paragraph2" color={theme.colors.gray_100}>
              <Strong>Will I be able to edit my profile at any time? </Strong>
            </Heading>
            <OL>
              <Typography
                fontFamily={"var(--font-400)"}
                variant="paragraph2"
                color={theme.colors.gray_100}
              >
                Yes. You can visit your profile at any time when you're logged
                in, edit your username and bio, and change your display picture.
                You can also add your social media handles to your profile.
              </Typography>
            </OL>
          </LI>
        </OL>

        <Typography
          fontFamily={"var(--font-400)"}
          variant="paragraph2"
          color={theme.colors.gray_100}
          textAlign="center"
        >
          Get in touch with us at <Strong>communities@betheshyft.com</Strong> if
          your question hasn't been answered. We're happy to help!
        </Typography>
      </Wrapper>
      <GlobalCss />
    </Container>
  );
};

export default FaqPageContent;
